<template>
  <el-dialog
    show-close
    visible
    :width="shipPlanRange == 'A' ? '820px' : '1140px'"
    :title="title"
    :close-on-click-modal="false"
    :before-close="() => $refs.main.cancel()"
    v-el-dialog-drag
  >
    <Main
      ref="main"
      :disabled="disabled"
      :isChange="isChange"
      :amzReplenishmentPeriodCode="amzReplenishmentPeriodCode"
      :shipPlanRange.sync="shipPlanRange"
      @close="close"
      @reload="$emit('reload')"
    />
    <span slot="footer">
      <el-button size="small" @click="$refs.main.cancel()">
        {{ $l('INDEX.btn_cancel') || 取消 }}
      </el-button>
      <el-button
        type="primary"
        size="small"
        v-if="!disabled"
        @click="$refs.main.save()"
      >
        {{ $l('INDEX.btn_save') || 保存 }}
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    type: { type: String, default: '' },
    amzReplenishmentPeriodCode: { type: String, default: '' },
  },
  data() {
    return {
      shipPlanRange: 'A',
      titleMap: {
        edit: this.$l('title_label_edit') || '编辑',
        change: this.$l('title_label_change') || '变更',
        add: this.$l('title_label_add') || '新增',
        detail: this.$l('title_label_detail') || '详情',
      },
    }
  },
  computed: {
    title() {
      return this.titleMap[this.type]
    },
    disabled() {
      return this.type === 'detail'
    },
    isChange() {
      return this.type === 'change'
    },
  },
  methods: {
    close() {
      this.$emit('close')
      this.$emit('update:visible', false)
    },
  },
}
</script>
